/**
 * EntitiesNavigationItems Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectEntityTypes } from '../../../../../../services/entityTypes/selectors';

// Utils
import orderBy from '../../../../../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectData = createDeepEqualSelector(
    selectEntityTypes,
    entityTypesState => Object.values(entityTypesState)
);

const selectOrderedData = createDeepEqualSelector(selectData, dataState =>
    orderBy(dataState, 'depth')
);

const makeSelectIds = () =>
    createDeepEqualSelector(
        selectOrderedData,
        orderedDataState =>
            orderedDataState && orderedDataState.map(value => value.id)
    );

export { selectData, selectOrderedData, makeSelectIds };
